var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCustomDataFormsIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_498_7026)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 18.5,
    r: 12.5,
    fill: "#E7E0F1"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 26,
    cy: 28,
    r: 7,
    fill: "#E7E0F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2 28.8V25.0333L27.2 18.0667C27.3614 17.902 27.5406 17.783 27.7377 17.7097C27.9348 17.6366 28.1307 17.6 28.3254 17.6C28.5376 17.6 28.741 17.6389 28.9357 17.7167C29.1304 17.7945 29.3074 17.9111 29.4667 18.0667L30.9334 19.5667C31.0798 19.728 31.1941 19.9072 31.2764 20.1043C31.3588 20.3015 31.4 20.4973 31.4 20.692C31.4 20.8867 31.3635 21.0858 31.2904 21.2893C31.217 21.4927 31.098 21.674 30.9334 21.8333L23.9667 28.8H20.2ZM21.8 27.2H23.3L27.1334 23.3667L26.4 22.6L25.6667 21.8667L21.8 25.7V27.2ZM9.80002 28.8C9.13336 28.8 8.56669 28.565 8.10002 28.095C7.63336 27.625 7.40002 27.06 7.40002 26.4V5.60001C7.40002 4.94001 7.63502 4.37501 8.10502 3.90501C8.57502 3.43501 9.14002 3.20001 9.80002 3.20001H20.2L26.6 9.60001V14.6667H24.2V11.2H18.6V5.60001H9.80002V26.4H17.8V28.8H9.80002ZM26.4 22.6L25.6667 21.8667L27.1334 23.3667L26.4 22.6Z",
    fill: "#873CAA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_498_7026"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomDataFormsIcon);
export default __webpack_public_path__ + "static/media/custom_data_forms_icon.e2fb616d34c54bd18f384539b6a4fb67.svg";
export { ForwardRef as ReactComponent };